import { render, staticRenderFns } from "./AlpineLayoutDefault.vue?vue&type=template&id=6bfceb36&scoped=true"
import script from "./AlpineLayoutDefault.vue?vue&type=script&lang=ts"
export * from "./AlpineLayoutDefault.vue?vue&type=script&lang=ts"
import style0 from "./AlpineLayoutDefault.vue?vue&type=style&index=0&id=6bfceb36&prod&lang=scss&scoped=true"
import style1 from "./AlpineLayoutDefault.vue?vue&type=style&index=1&id=6bfceb36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfceb36",
  null
  
)

export default component.exports